import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';

export const CpWidgetLoadingSkeletonWrapper = styled.div<{
  bg?: string;
}>`
  width: 100%;
  height: 15rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ bg }) => bg || 'var(--cp-white)'};
`;

export interface CpLoadingProps {
  variantType: CpWidgetVariantType;
  styles?: Record<string, unknown>;
  input: Record<string, unknown>;
}

export const CpLoadingTitle = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    display: block;
    max-width: 70% !important;
    width: 440px !important;
  }
  .ant-skeleton-button,
  &.ant-skeleton-button {
    width: 100% !important;
  }
  margin-bottom: var(--cp-spacing-04);
`;

export const CpLoadingDesc = styled(Skeleton.Button)`
  .ant-skeleton,
  .ant-skeleton-button,
  &.ant-skeleton,
  &.ant-skeleton-button,
  & {
    display: block;
    max-width: 70% !important;
    width: 670px !important;
  }

  margin-bottom: var(--cp-spacing-06);
`;

export const TitleAndDesc: React.FC<{ title: string; desc: string }> = () => {
  return (
    <>
      <CpLoadingTitle active />
      <CpLoadingDesc active />
    </>
  );
};
